module.exports = __webpack_public_path__ + "img/102ne.763dbf79.svg";